import {ChangeDetectorRef, Component, DestroyRef, Input} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ImportExcelService, TypeLogImportExcel} from '@shared/services/global';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';


@Component({
  standalone: false,
  selector: 'app-import-excel-common-log',
  templateUrl: 'import-excel-modal.component.html',
})
export class ImportExcelNewModalComponent {
  private importExcelService!: ImportExcelService;

  @Input()
  set service(service: ImportExcelService) {
    this.importExcelService = service;
    service.importStateChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.cdr.markForCheck());
  }

  get service(): ImportExcelService {
    return this.importExcelService;
  }

  @Input() useOnlyContent = false;

  activeTab: TypeLogImportExcel = 'all';

  constructor(
    public activeModal: NgbActiveModal,
    private readonly cdr: ChangeDetectorRef,
    private readonly destroyRef: DestroyRef,
  ) {

  }
}
